import React from 'react';
import DepartmentTaskManager from '../../components/DepartmentTaskManager';

const ProjectsTaskManager = () => {
  return <DepartmentTaskManager department="PROJECTS" />;
};

export default ProjectsTaskManager;
